import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { parseFarmerProfile } from "@helpers/readFarmerProfile";

export function API0() {
  const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    timeout: 10000,
  });
  api.defaults.headers.post["Content-Type"] = "application/json ";
  api.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  api.defaults.headers.common["Authorization"] = localStorage.getItem("token");
  api.defaults.withCredentials = true;

  // api.defaults.headers.common["Authorization"] =

  api.interceptors.response.use(
    (res) => {
      // const sucsses = res?.data?.result?.message;
      // toast.success(sucsses);
      return res.data;
    },
    (error) => {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        window.location.href = `/login?return-to=${window.location.pathname}`;
        localStorage.clear(["profile"]);
        localStorage.removeItem("isExpert");
        localStorage.removeItem("expertId");

        const errorMessage = error?.response?.data?.errors[0]?.message;
        toast.error(errorMessage);
      } else if (axios.AxiosError.ETIMEDOUT === error.code) {
        toast.error("مشکل در اتصال به اینترنت    ");
        Swal.fire({
          icon: "error",

          title: "خطا در اتصال به اینترنت ",
          text: "لطفا وضعیت اتصال به اینترنت خود را بررسی کنید ",
          confirmButtonText: "تلاش مجدد ",
        }).then((res) => {
          if (res.isConfirmed) {
            window.location.reload();
          }
        });
      } else if (axios.AxiosError.ERR_NETWORK === error.code) {
        toast.error("اتصال اینترنت برقرار نمی باشد");
        Swal.fire({
          icon: "error",

          title: "خطا در اتصال به اینترنت ",
          text: "اتصال اینترنت برقرار نمی باشد لطفا وضعیت اتصال اینترنت دستگاه خود را بررسی کنید",
          confirmButtonText: "تلاش مجدد ",
        }).then((res) => {
          if (res.isConfirmed) {
            window.location.reload();
          }
        });
      } else {
        const errorMessage = error?.response?.data?.errors[0]?.message;
        toast.error(errorMessage);
      }
    }
  );

  return api;
}
const REQUEST_HEADERS = {
  "Content-Type": "application/json",
};
export function API141() {
  const api = axios.create({
    baseURL: process.env.REACT_APP_EXPERT_URL,
    headers: REQUEST_HEADERS,
    timeout: 10000,
  });
  api.defaults.headers.post["Content-Type"] = "application/json ";
  api.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  api.defaults.headers.common["Authorization"] = localStorage.getItem("token");

  api.defaults.withCredentials = false;
  // api.defaults.headers.common["Authorization"] =

  api.interceptors.response.use(
    (res) => {
      // const sucsses = res?.data?.result?.message;
      // toast.success(sucsses);
      return res.data;
    },
    (error) => {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        window.location.href = `/login?return-to=${window.location.pathname}`;
        localStorage.removeItem("isExpert");
        localStorage.removeItem("expertId");
        localStorage.removeItem("token");
      } else if (axios.AxiosError.ETIMEDOUT === error.code) {
        toast.error("مشکل در اتصال به اینترنت، در حال تلاش مجدد");
        Swal.fire({
          icon: "error",
          title: "خطا در اتصال به اینترنت ",
          text: "خطا در اتصال به اینترنت",
          confirmButtonText: "تلاش مجدد ",
        }).then((res) => {
          if (res.isConfirmed) {
            window.location.reload();
          }
        });
      } else if (axios.AxiosError.ERR_NETWORK === error.code) {
        // toast.error("1اتصال اینترنت برقرار نمی باشد");
        // Swal.fire({
        //   icon: "error",
        //   title: "خطا در اتصال به اینترنت ",
        //   text: "خطا در اتصال به اینترنت",
        //   confirmButtonText: "تلاش مجدد ",
        // }).then((res) => {
        //   if (res.isConfirmed) {
        //     window.location.reload();
        //   }
        // });
      } else {
        const errorMessage = error?.response?.data?.errors[0]?.message;
        toast.error(errorMessage);
      }
    }
  );

  return api;
}

export function API2() {
  const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    timeout: 10000,
  });
  api.defaults.headers.post["Content-Type"] = "application/json ";
  api.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  api.defaults.headers.common["Authorization"] = localStorage.getItem("token");

  api.defaults.withCredentials = true;

  // api.defaults.headers.common["Authorization"] =

  api.interceptors.response.use(
    (res) => {
      // const sucsses = res?.data?.result?.message;
      // toast.success(sucsses);
      return res.data;
    },
    (error) => {
      if (
        error?.response?.status === 401 ||
        error?.response?.status === 403 ||
        error?.response?.status === 404
      ) {
        window.location.href = `/login?return-to=${window.location.pathname}`;
        localStorage.clear(["profile"]);
        localStorage.removeItem("isExpert");
        localStorage.removeItem("expertId");
        localStorage.removeItem("token");

        const errorMessage = error?.response?.data?.errors[0]?.message;
        toast.error(errorMessage);
      } else if (axios.AxiosError.ETIMEDOUT === error.code) {
        toast.error("مشکل در اتصال به اینترنت، در حال تلاش مجدد");
        Swal.fire({
          icon: "error",
          title: "خطا در اتصال به اینترنت ",
          text: "خطا در اتصال به اینترنت",
          confirmButtonText: "تلاش مجدد ",
        }).then((res) => {
          if (res.isConfirmed) {
            window.location.reload();
          }
        });
      } else if (axios.AxiosError.ERR_NETWORK === error.code) {
        toast.error("اتصال اینترنت برقرار نمی باشد");
        Swal.fire({
          icon: "error",
          title: "خطا در اتصال به اینترنت ",
          text: "خطا در اتصال به اینترنت",
          confirmButtonText: "تلاش مجدد ",
        }).then((res) => {
          if (res.isConfirmed) {
            window.location.reload();
          }
        });
      } else {
        const errorMessage = error?.response?.data?.errors[0]?.message;
        toast.error(errorMessage);
      }
    }
  );

  return api;
}
export async function login(data) {
  const response = await API0().post("auth/login", data);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function errorBoundary(data) {
  const response = await API0().post("health/errors", data);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getNutritionPrograms() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/questionnaires`);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getFarmerProfile(FarmerId) {
  const farmerId =
    FarmerId && typeof FarmerId === "string"
      ? FarmerId
      : parseFarmerProfile()?.id;

  if (farmerId) {
    const response = await API0().get(`farmers/${farmerId}`);
    if (response) {
      localStorage.setItem(
        "profile",
        JSON.stringify(response?.result?.data?.farmer)
      );
      return response?.result?.data;
    } else {
      throw new Error();
    }
  } else {
  }
}

export async function getSwitchedFarmerProfile(farmerId) {
  const response = await API0().get(`farmers/${farmerId}`);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function logout() {
  const response = await API0().delete("/auth/logout");
  if (response) {
    Cookies.remove("farmerId");
    localStorage.removeItem("profile");
    localStorage.removeItem("token");

    return response;
  } else {
    throw new Error();
  }
}

export async function getFarmerVisits() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/visits`);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getVisitReportData(visitId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/visits/${visitId}`);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getFarmerPrescriptions() {
  const response = await API0().get("prescriptions");
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function growingYearsStatics() {
  const response = await API0().get("statics/growing-seasons-years");
  if (response) {
    return response?.result?.data;
  } else {
    throw Error();
  }
}

export async function getAllGrowingSeasonYears() {
  const response = await API0().get("statics/growing-seasons-years");
  if (response) {
    return response?.result;
  } else {
    throw Error();
  }
}

export async function getStaticProvinces() {
  const response = await API0().get("/statics/provinces");
  return response?.result?.data?.provinces;
}

export async function getStaticCities() {
  const response = await API0().get("/statics/cities");
  return response?.result?.data?.cities;
}

export async function createWeatherStation(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/weather-stations`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getWeatherStations() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/weather-stations`);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function farmerRegister(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().put(`/farmers/${farmerId}`, data);

  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function farmerRegisterPost(data) {
  const response = await API0().post("/farmers", data);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getStaticsProducts() {
  const response = await API0().get("/statics/products");
  if (response) {
    return response?.result?.data?.products;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getAllProducts() {
  const response = await API0().get("/statics/products");
  if (response) {
    return response?.result;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function updateFarmerProfile(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().put(`/farmers/${farmerId}`, data);

  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw new Error();
  }
}

export async function deleteWeatherStation(weatherStationId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().delete(
    `/farmers/${farmerId}/weather-stations/${weatherStationId}`
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getWeatherStation(weatherStationId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/weather-stations/${weatherStationId}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getFarmersFields() {
  const response = await API0().get("/statics/farmers-fields");
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function updateWeatherStation({ data, weatherStationId }) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().put(
    `/farmers/${farmerId}/weather-stations/${weatherStationId}`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data?.weatherStation?.invoice?.id;
  } else {
    throw new Error();
  }
}

export async function getPaymentInfos(data) {
  const response = await API0().post("/payments", data);

  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data?.paymentGatewayURL;
  } else {
    throw new Error();
  }
}

export async function getFarmerWeatherStation(weatherStationId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/weather-stations/${weatherStationId}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getFarmerWeatherStationAlert(weatherStationId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/weather-stations/${weatherStationId}/alerts`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getFarmerPaymentInfo(query) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  let queryString = `/farmers/${farmerId}/invoices`;
  if (query) {
    queryString += query;
  }
  const response = await API0().get(queryString);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getPaymentPageInfo(invoiceId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;

  const response = await API0().get(
    `/farmers/${farmerId}/invoices/${invoiceId}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getNearExperts() {
  const farmer = JSON.parse(localStorage.getItem("profile"));
  let queryString = "/experts?limit=10";
  if (farmer.provinceId) {
    queryString += `&provinceId=${farmer.provinceId}`;
  }
  const response = await API141().get(queryString);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getFields() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/farms`);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getFarmerField(farmId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/farms/${farmId}`);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getPrescriptions() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/prescriptions`);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function registerField(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(`/farmers/${farmerId}/farms`, data);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function updateField(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().put(
    `/farmers/${farmerId}/farms/${data?.farmId}`,
    data?.editedData
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getClimaticHistory(weatherStationId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/weather-stations/${weatherStationId}/climatic-history`,
    {
      timeout: 120000,
    }
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getFieldHistory(farmId, orderBy = -1) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/farms/${farmId}/history?sort=1&orderBy=${orderBy}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw Error();
  }
}

export async function getAllGrowingSeasons(farmId, history) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/farms/${farmId}/seasons`,
    {
      params: history,
    }
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw Error();
  }
}

export async function getDataCollapseSeason(farmId, seasonsId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/farms/${farmId}/seasons/${seasonsId}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw Error();
  }
}

export async function getGrowingSeason(farmId, seasonsId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/farms/${farmId}/seasons/${seasonsId}`
  );
  if (response) {
    return response?.result;
  } else {
    throw Error();
  }
}

export async function deleteSeasons(season) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().delete(
    `/farmers/${farmerId}/farms/${season?.farmId}/seasons/${season?.id}`
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getDataAllCertificate(farmId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/farms/${farmId}/history`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getDataAllWaterCertificate(irrigationSourceId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/irrigation-sources/${irrigationSourceId}/history`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getDataAllMechanizationCertification(irrigationSourceId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/irrigation-sources/${irrigationSourceId}/history`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }

}

export async function getChillingRequests() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/chilling-requirements`
  );

  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getInRadiusWeatherStations(latitude, longitude) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/weather-stations?latitude=${latitude}&longitude=${longitude}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getAllWeatherStationsInRadius(latitude, longitude) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/weather-stations?latitude=${latitude}&longitude=${longitude}`
  );
  if (response) {
    return response?.result;
  } else {
    throw Error();
  }
}

export async function sendChillingRequest(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/chilling-requirements`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getChillingRequirementReport(chillingRequirementId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/chilling-requirements/${chillingRequirementId}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getCultivarRecommendationReport(
  cultivarRecommendationId
) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/cultivar-recommendations/${cultivarRecommendationId}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getHarvestRecommendationReport(harvestRecommendationId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/harvest-date-recommendations/${harvestRecommendationId}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getCultivarRecommendations() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/cultivar-recommendations`
  );

  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getHarvestRecommendations() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/harvest-date-recommendations`
  );

  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function sendHarvestRequest(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/harvest-date-recommendations`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw Error();
  }
  // return response?.result?.data?.cities
}

export async function growingSeasonField({ growingSeasonData, farmId }) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/farms/${farmId}/seasons`,
    growingSeasonData
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw Error();
  }
}

export async function getGrowingSeasons(farmId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/farms/${farmId}/seasons`
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw Error();
  }
}

export async function addNewGrowingSeason({ season, farmId }) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/farms/${farmId}/seasons`,
    season
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw Error();
  }
}

export async function editGrowingSeasonForm({ season, farmId, seasonId }) {
  season.centerCoordinates = [1, 2];
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().put(
    `/farmers/${farmerId}/farms/${farmId}/seasons/${seasonId}`,
    season
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function sendCultivarRecomendation(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/cultivar-recommendations`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function sendSowingDate(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/sowing-date-recommendations`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getSowingDateRecommendations() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;

  const response = await API0().get(
    `/farmers/${farmerId}/sowing-date-recommendations`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getSowingDateReport(sowingRecommendationId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/sowing-date-recommendations/${sowingRecommendationId}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw Error();
  }

  // return response?.result?.data?.cities
}

export async function getExperiments(id) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/experiments?categoryId=${id}`
  );

  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getExperimentsReportResults(experimentId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/experiments/${experimentId}`
  );

  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function calculateCost(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/visits/calculate-cost`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function createVisit(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(`/farmers/${farmerId}/visits`, data);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getProductsCultivars({ weatherStationId, farmId }) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/products-cultivars/?weatherStationId=${weatherStationId}&farmId=${farmId}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getProductsCultivarsBySeasonId({
  weatherStationId,
  farmId,
  seasonId,
}) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/products-cultivars?weatherStationId=${weatherStationId}&farmId=${farmId}&seasonId=${seasonId}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}
export async function getProductsParameters(id) {
  const response = await API0().get(`/products-parameters?productId=${id}`);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}
export async function createIrrigationSource(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/irrigation-sources
  `,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function createExperiments(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/experiments
  `,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getWeedPrescriptionData(prescriptionId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/prescriptions/${prescriptionId}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getIriigationSystem() {
  const response = await API0().get("/statics/farmers-fields");
  if (response) {
    return response?.result?.data?.farmersFields["IRRIGATION_SYSTEM"];
  } else {
    throw new Error();
  }
}

export async function getIrrigationSource() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/irrigation-sources`);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getAllIrrigationSource() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/irrigation-sources`);
  if (response) {
    return response?.result;
  } else {
    throw new Error();
  }
}

export async function editIrrigationSource({ irrigationSourceId, data }) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().put(
    `/farmers/${farmerId}/irrigation-sources/${irrigationSourceId}`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function deleteIrrigationSource(irrigationSourceId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().delete(
    `/farmers/${farmerId}/irrigation-sources/${irrigationSourceId}`
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function createPool(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/pools
  `,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getFarmerPoolList() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/pools`);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getYieldGapJson(productId) {
  const response = await API0().get(`/samples/yield-gap/${productId}`);
  if (response) {
    const seyed = axios
      .get(response.result.data.sample.data.files[0])
      .then((res) => {
        return res;
      });
    return seyed;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function createYieldGap(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(`/farmers/${farmerId}/yield-gaps`, data);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getWeedData(page, limit, name, sort, productId) {
  let params = {};
  if (page) params["page"] = page;
  if (limit) params["limit"] = limit;
  if (name) params["name"] = name;
  if (sort) params["typeId"] = sort;
  if (productId) params["productId"] = productId;
  const response = await API0().get(`/weeds`, { params: params });
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function sendDataCartWeed(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/prescriptions`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw new Error();
  }
}

export async function sendSaffronRequest(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/first-saffron-irrigation-requests`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getDataSaffron(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/first-saffron-irrigation-requests`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw new Error();
  }
}

export async function editPool({ poolId, data }) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().put(
    `/farmers/${farmerId}/pools/${poolId}`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getYieldGapsList() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/yield-gaps`);
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getYieldGapsReport(yieldGapId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/yield-gaps/${yieldGapId}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getSaffronReport(firstSaffronIrrigationId, data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/first-saffron-irrigation-date-recommendations/${firstSaffronIrrigationId}`,
    data
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function updateDateSaffronReport(firstSaffronIrrigationId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().put(
    `/farmers/${farmerId}/first-saffron-irrigation-date-recommendations/${firstSaffronIrrigationId}`
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getExperimentParams(categoryId, typeId, kindId) {
  const response = await API0().get(
    `/statics/experiments-parameters${
      categoryId ? `?categoryId=${categoryId}` : ""
    }${typeId ? `&typeId=${typeId}` : ""}${kindId ? `&kindId=${kindId}` : ""}`
  );
  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function editExperimentResult({ experimentId, data }) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().put(
    `/farmers/${farmerId}/experiments/${experimentId}/submission-result`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function deleteExperiment(experimentId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().delete(
    `/farmers/${farmerId}/experiments/${experimentId}`
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

// new sample
export async function addExperimentSampleResult({ experimentId, samples }) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/experiments/${experimentId}/submission-result/add-sample`,
    { samples }
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function createLabHistory(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/experiments/submit-result`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getDate(data) {
  const response = await API0().get(`/statics/datetime`, data);
  if (response) {
    return response;
  } else {
    throw new Error();
  }
}

export async function getWeatherStationHistory(weatherStationId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/weather-stations/${weatherStationId}/history`
  );

  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function discountCodeValidation(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/discounts/apply`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getDiscountCodeList() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/discounts`);

  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function deleteFields(farmId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().delete(`/farmers/${farmerId}/farms/${farmId}`);
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function expertGetAccess(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/experts-access/search`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function createExpertAccess(data) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().post(
    `/farmers/${farmerId}/experts-access`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getExpertAccess(accessId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(
    `/farmers/${farmerId}/experts-access/${accessId}`
  );

  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function getFarmerExperts() {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().get(`/farmers/${farmerId}/experts-access`);

  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}

export async function deleteExpert(accessId) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().delete(
    `/farmers/${farmerId}/experts-access/${accessId}`
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function editExpertAccess({ accessId, data }) {
  const farmerId = JSON.parse(localStorage.getItem("profile"))?.id;
  const response = await API0().put(
    `/farmers/${farmerId}/experts-access/${accessId}`,
    data
  );
  if (response) {
    const sucsses = response?.result?.message;
    toast.success(sucsses);
    return response?.result?.data;
  } else {
    throw new Error();
  }
  // return response?.result?.data?.cities
}

export async function getExpertFarmers(userId) {
  const response = await API0().get(`/experts/${userId}/access-farmers`);

  if (response) {
    return response?.result?.data;
  } else {
    throw new Error();
  }
}
